export default __webpack_public_path__ + "static/media/settings2.7a981987.svg";